import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import menuIcon from '../../../../assets/FD_Logo.png';


import { Moment as MomentType } from 'moment';

import style from './driverCheckin.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '96%',
      height: '48px',
      margin: '25px 0 0 2%',
      textTransform: 'none'
    },

    tabsRoot: {
      width: '100%',
      background: 'var(--primaryblue)',
      marginTop: '10px'
    },
    tabsIndicator: {
      backgroundColor: '#1890ff00',
    },
    tabRoot: {
      borderBottom: '1px solid #e8e8e8',
      background: 'var(--primaryblue)',
      color: '#FFF',
      boxSizing: 'border-box',
      border: '1px solid #FFF',
      '&$tabSelected': {
      }
    },
  });

interface DropOffOrderDriverProps {
  classes: any;
  handleChange: (event: any, value: number) => void;
};

const driverETADriver = (props: DropOffOrderDriverProps) => {

  const { classes } = props;

  return (
    <div className={style.container}>

      <div className={style.header}>
        <img alt="logo" src={menuIcon} className={style.img} />

      </div>
    </div>
  );
}

export default withStyles(styles)(driverETADriver);